'use client';

import React from 'react';
import { styled } from 'styled-components';
import { colors } from '../../../abstracts';
import { Icon } from '../../Icon';
const Button = styled.button.withConfig({
  componentId: "aui__sc-1xdgzlh-0"
})(["cursor:pointer;z-index:1000;position:absolute;right:14px;top:12px;border:none;padding:0.5rem;border-radius:9999px;background-color:", ";&:hover{background-color:", ";}&:active{background-color:", ";}> span{box-sizing:content-box;}"], colors.white, colors.neutralBrighter, colors.neutralBright);
export const DrawerCloseButton = ({
  onClick,
  onTouchEnd
}) => /*#__PURE__*/React.createElement(Button, {
  onClick: () => onClick(),
  onTouchEnd: () => onTouchEnd(),
  "aria-label": "close drawer",
  "data-testid": "close-drawer-button"
}, /*#__PURE__*/React.createElement(Icon.SSR, {
  size: "large",
  src: "close-x",
  color: "black"
}));